RivalIQ.apps.Overview.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;


    const LayoutWithBenchmarkChooserMixin = {
        showActions: function () {
            const me = this;

            me.actions.show(new App.views.ChangeBenchmarkCompaniesFilterButton({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });

            me.showExportDropdown();
        },

        _loadData: function () {
            const me = this;

            const props = me.getProps();
            const testMetric = _.defaults({
                dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                companyId: props.focusCompanyId,
                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                property: 'engagement_total'
            }, props);

            return new RivalIQ.collections.MetricDefinitions([testMetric])
                .fetch()
                .done(function (results) {
                    const result = results.at(0);

                    me.hasInvalidDateError = Boolean(result.error?.invalidDate);
                    if (me.hasInvalidDateError) {
                        me.invalidDateError = result.error;
                    } else {
                        delete me.invalidDateError;
                    }
                });
        },

        _showInvalidDateError: function () {
            const me = this;

            const errorView = Marionette.ItemView.extend({
                template: '#overviewInvalidDateTemplate',
                serializeData: _.constant(me.invalidDateError)
            });
            me.dashboardError.show(new errorView());
            me.dashboardError.$el.show();
        }
    };

    views.LayoutWithBenchmarkChooser = Dashboard.views.CurationLayout.mixin({

        regions: _.defaults({
            dashboardError: '.dashboard-error'
        }, Dashboard.views.CurationLayout.prototype.regions),

        mixins: {
            LayoutWithBenchmarkChooserMixin: LayoutWithBenchmarkChooserMixin,
            LoadDataWithBuffering: RivalIQ.apps.Dashboard.mixins.LoadDataWithBuffering
        }
    });

    views.CurationWidgetsLayoutWithBenchmarkChooser = Dashboard.views.ColumnCurationView.mixin({
        regions: _.defaults({
            dashboardError: '.dashboard-error'
        }, Dashboard.views.ColumnCurationView.prototype.regions),

        mixins: {
            LayoutWithBenchmarkChooserMixin: LayoutWithBenchmarkChooserMixin
        }
    });

}, window.moment);
